import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
var PageButton = /*#__PURE__*/function (_PureComponent) {
  _inherits(PageButton, _PureComponent);
  var _super = _createSuper(PageButton);
  function PageButton(props) {
    var _this;
    _classCallCheck(this, PageButton);
    _this = _super.call(this, props);
    _this.changePageHandler = _this.changePageHandler.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(PageButton, [{
    key: "changePageHandler",
    value: function changePageHandler() {
      var _this$props = this.props,
        pageNumber = _this$props.pageNumber,
        changePage = _this$props.changePage;
      changePage(pageNumber);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        pageNumber = _this$props2.pageNumber,
        activePage = _this$props2.activePage,
        addEllipsis = _this$props2.addEllipsis;
      return /*#__PURE__*/React.createElement(Fragment, null, addEllipsis && /*#__PURE__*/React.createElement("li", {
        className: "disabled"
      }, /*#__PURE__*/React.createElement("a", {
        href: "#"
      }, "...")), " ", /*#__PURE__*/React.createElement("li", {
        className: pageNumber === activePage ? 'active' : null
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: this.changePageHandler
      }, " ", pageNumber + 1)));
    }
  }]);
  return PageButton;
}(PureComponent);
PageButton.propTypes = {
  pageNumber: PropTypes.number.isRequired,
  activePage: PropTypes.number.isRequired,
  changePage: PropTypes.func.isRequired,
  addEllipsis: PropTypes.bool.isRequired
};
export default PageButton;